module.exports = __webpack_public_path__ + "img/filter_center_focus.6312fa52.svg";